<template>
  <div>
    <div
      class="card card-body mb-4 relative pt-8 bordered"
      v-for="(item, index) in items"
      :name="`${listId}-${item.id}`"
      :key="item.id"
    >
      <div class="absolute top-0 left-0 btn-primary rounded py-1 px-2 -ml-1 -mt-1">
        <span class="font-small-2">#{{ index + 1 }}</span>
      </div>
      <slot :id="item.id" :item="item" :index="index" />
      <vx-tooltip
        class="absolute top-0 right-0 -mr-1 -mt-1"
        text="Eliminar ítem"
        position="top"
      >
        <vs-button
          class="rounded py-1 px-2"
          size="small"
          color="danger"
          icon="clear"
          @click="removeItem(index)"
        />
      </vx-tooltip>
    </div>

    <b-button
      class="btn-block"
      @click="addItem"
      variant="primary"
      size="sm"
    >
      Agregar ítem
    </b-button>
  </div>
</template>

<script>
import { uuid } from 'vue-uuid';

import { showNotification } from '@/febos/global/customDocuments/utils/notifications';
import { scrollToNamedElement } from '@/febos/global/customDocuments/utils/scroll';

export default {
  name: 'list-structure',
  data() {
    return {
      listId: uuid.v4(),
    };
  },
  props: {
    items: {
      type: Array,
      required: true,
    },
    defaultItem: {
      type: Object,
      default: () => ({}),
    },
    minItems: {
      type: Number,
      default: 1,
    },
  },
  methods: {
    addItem() {
      const newItem = {
        id: uuid.v4(),
        ...this.defaultItem,
      };
      this.items.push(newItem);
      this.$emit('add-item', newItem);
      this.$nextTick(() => {
        scrollToNamedElement(`${this.listId}-${newItem.id}`);
      });
    },
    removeItem(index) {
      if (this.items.length <= this.minItems) {
        showNotification(
          this,
          `El mínimo de ítems es ${this.minItems}, agregue más ítems antes de eliminar.`,
          'No se puede eliminar',
          {
            icon: 'icon-alert-circle',
            color: 'danger',
          }
        );
        return;
      }
      this.items.splice(index, 1);
      this.$emit('remove-item', index);
    },
  },
  mounted() {
    if (!this.items.length || this.items.length < this.minItems) {
      for (let i = 0; i < this.minItems; i += 1) {
        this.addItem();
      }
    }
  }
};
</script>
<style>
.bordered {
  border: 1px solid #d8d6de;
}
</style>
